import { Fragment, h } from 'preact';

import Store from '../../stores/Store';

import HeaderNotLogin from './not-login';
import HeaderIsLogin from './is-login';

import HeaderBottomIsLogin from './is-login-bottom';
import { GlobalState } from '../../states/global-state';

const Header = () => {
  const store = new Store();

  const deviceType = GlobalState.device.value;

  if (store.isLoggedIn()) {
    if (deviceType == 'desktop') {
      return <HeaderIsLogin />;
    } else if (deviceType == 'mobile') {
      return (
        <Fragment>
          <HeaderIsLogin />
          <HeaderBottomIsLogin />
        </Fragment>
      );
    }
  }
  return <HeaderNotLogin />;
};

export default Header;
